import { useQuery, useQueryClient } from '@tanstack/react-query'
import { i18n } from '@zet/localization'

import { getAppComms } from './functions'

function useAppComms() {
  const queryClient = useQueryClient()
  return useQuery(['appComms', { locale: i18n.locale }], () => getAppComms(), {
    enabled: false,
    onSuccess: (data) => {
      if (Object.keys(data).length > 0) {
        Object.keys(data).forEach((value) => {
          queryClient.setQueryData([`${value}-comms`], data[value])
        })
      }
      return data
    },
  })
}

const useSpecificAppComms = (value: string) => {
  const queryClient = useQueryClient()
  return useQuery(
    ['specificAppComms', value],
    () => {
      const data = queryClient.getQueryData([`${value}-comms`])
      return data
    },
    { staleTime: Infinity }
  )
}

export { useAppComms, useSpecificAppComms }
